module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-12.3906850f.png";